<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-sm-12">
      <div
        class="d-flex align-items-center justify-content-between mb-3 flex-wrap header-with-pill"
      >
        <h3 class="mb-0">Evaluación RTC</h3>
        <div
          class="pill-image ms-3 shrink-0"
          [ngClass]="{ offline: !(isOnline$ | async) }"
          [@pillAnim]="(isOnline$ | async) ? 'online' : 'offline'"
        >
          <label for="" class="">{{
            (isOnline$ | async) ? "Conectado" : "Sin conexión"
          }}</label>
          <ng-container *ngIf="isOnline$ | async; else offlineSvg">
            <img src="assets/images/icons/online.svg" alt="Online" />
          </ng-container>
          <ng-template #offlineSvg>
            <svg
              width="15"
              height="11"
              viewBox="0 0 15 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.4834 0.0836508C5.99703 -0.0211864 6.52775 -0.0276065 7.04395 0.0650961C7.56023 0.157893 8.05291 0.347748 8.49121 0.62369C8.92933 0.899616 9.30581 1.25658 9.59766 1.67252C9.78249 1.93607 9.93038 2.2205 10.04 2.51822L11.7256 1.25943C11.9222 1.11288 12.2008 1.15382 12.3477 1.35025C12.4941 1.54684 12.4533 1.82557 12.2568 1.97232L10.7773 3.07681C11.0988 3.11668 11.4148 3.19461 11.7178 3.30826C12.2034 3.49047 12.6469 3.76188 13.0215 4.10806C13.396 4.45431 13.6946 4.86896 13.9004 5.32584C14.106 5.78262 14.2145 6.27419 14.2197 6.77115C14.2249 7.26816 14.1267 7.76171 13.9307 8.22232L13.8525 8.39322C13.6606 8.78677 13.3984 9.14668 13.0771 9.45572L12.9365 9.58463C12.6002 9.87765 12.2126 10.1134 11.791 10.2809L11.6084 10.3483C11.241 10.4743 10.8558 10.5476 10.4658 10.5661L10.2705 10.571H3.16016L2.84766 10.5563C2.33463 10.5078 1.84424 10.3385 1.41699 10.069L0.736328 10.5788C0.539792 10.7251 0.261014 10.6842 0.114258 10.4879C-0.0321656 10.2914 0.00877295 10.0127 0.205078 9.86588L0.724609 9.47721C0.291821 8.97841 0.0378557 8.35924 0.00390625 7.7106L3.99005e-09 7.56119C-3.15154e-05 6.96355 0.186678 6.38102 0.533203 5.88736L0.692383 5.68131C1.14032 5.14762 1.76509 4.77414 2.46484 4.62369C2.35983 4.19765 2.33322 3.75758 2.38672 3.32389L2.41504 3.13834C2.4914 2.7066 2.64632 2.29109 2.87207 1.9108L2.97363 1.74967C3.25466 1.32707 3.62091 0.961518 4.05176 0.675448C4.42888 0.425087 4.84884 0.23935 5.29199 0.12662L5.4834 0.0836508ZM2.2041 9.48111C2.49968 9.60953 2.82445 9.68228 3.16016 9.68228H10.2705C10.6808 9.68223 11.0864 9.60433 11.4629 9.45474C11.8393 9.30516 12.1782 9.08701 12.4609 8.8151C12.7436 8.5432 12.9648 8.22239 13.1133 7.87369C13.2616 7.52523 13.3349 7.15324 13.3311 6.77994C13.3271 6.4066 13.2455 6.03595 13.0898 5.6901C12.934 5.34421 12.7063 5.028 12.418 4.76139C12.1293 4.49459 11.7851 4.28279 11.4053 4.14029C11.0254 3.99783 10.6183 3.92741 10.208 3.93521C10.0512 3.93818 9.90212 3.89886 9.77148 3.82877L2.2041 9.48111ZM6.8877 0.940096C6.48221 0.867231 6.06446 0.871446 5.66113 0.953768C5.25806 1.03608 4.87831 1.19378 4.54395 1.41568C4.20953 1.6377 3.92722 1.91947 3.71289 2.24185C3.4988 2.56396 3.35573 2.92149 3.29004 3.29264C3.22442 3.66386 3.23763 4.04484 3.32813 4.41178C3.38537 4.64487 3.34598 4.89181 3.21875 5.09537C3.09137 5.29905 2.88624 5.44232 2.65137 5.49283C2.13917 5.60301 1.69024 5.87468 1.37305 6.2526C1.05664 6.62965 0.888647 7.09143 0.888672 7.56119C0.888813 8.06417 1.08301 8.55426 1.44043 8.94205L9.2832 3.08267C9.20047 2.76435 9.06406 2.45876 8.87012 2.18228C8.64734 1.86481 8.35781 1.58991 8.01758 1.37564C7.67728 1.1614 7.29291 1.01301 6.8877 0.940096Z"
                fill="#D59522"
              />
            </svg>
          </ng-template>
        </div>
      </div>
      <form [formGroup]="optionsForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-sm-4">
            <label for="business" class="form-label"
              >Negocio <span class="text-danger fs-4">*</span></label
            >
            <div class="form-group">
              <select
                id="business"
                formControlName="business"
                class="form-select"
                (change)="onBusinessChanged()"
              >
                <option value="" selected>Seleccionar...</option>
                <option
                  *ngFor="let business of master.BUSINESSES"
                  [ngValue]="business.valueId"
                >
                  {{ business.valueToDisplay }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <label for="type" class="form-label"
              >Tipo <span class="text-danger fs-4">*</span></label
            >
            <div class="form-group">
              <select id="type" formControlName="type" class="form-select">
                <option value="" selected>Seleccionar...</option>
                <option
                  *ngFor="let type of typesForBusinessSelected"
                  [ngValue]="type.valueId"
                >
                  {{ type.valueToDisplay }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <label for="licensePlate" class="form-label"
              >Patente <span class="text-danger fs-4">*</span></label
            >
            <div class="form-group">
              <input
                type="text"
                id="licensePlate"
                formControlName="licensePlate"
                class="form-control immutable-field"
                placeholder="AABB00"
                appInputUppercase
              />
            </div>
          </div>
        </div>
        <div class="row g-3 align-items-center justify-content-center mt-3">
          <div class="col-auto text-center">
            <button
              id="rtc-options-edit-submit"
              type="submit"
              class="btn btn-outline-primary rtc-chip"
              [class.loading]="disableLoadButton"
              [disabled]="
                !optionsForm.valid || disableLoadButton || !(isOnline$ | async)
              "
              aria-live="polite"
              aria-label="Cargar evaluación"
            >
              <!-- Cuando está en loading, mostramos únicamente el spinner centrado -->
              <ng-container *ngIf="disableLoadButton; else normalLabel">
                <span class="rtc-spinner" aria-hidden="true">
                  <span
                    class="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </span>
              </ng-container>
              <ng-template #normalLabel>
                <span class="btn-text">Cargar evaluación</span>
              </ng-template>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-sm-12" *ngIf="!isGettingEntity && selectedEntity">
      <!-- Resumen del vehículo estilo tabla/row -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="entity-summary">
          <div class="entity-col">
            <small class="label">Negocio</small>
            <div class="value">
              {{
                (selectedEntity.business || "").toUpperCase()
                  | master : "BUSINESSES" : selectedEntity.business
              }}
            </div>
          </div>
          <div class="entity-col">
            <small class="label">Tipo</small>
            <div class="value">
              {{ selectedEntity.type || "" | master : "VEHICLES#BRANDS" }}
            </div>
          </div>
          <div class="entity-col">
            <small class="label">Patente</small>
            <div class="value">{{ selectedEntity.licensePlate }}</div>
          </div>
          <div class="entity-col">
            <small class="label">Equipo</small>
            <div class="value">{{ selectedEntity.sapId! | sapId }}</div>
          </div>
          <div class="entity-action">
            <a class="details-link" (click)="openDetails(detailsTemplate)"
              >Ver detalles</a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Detalles del vehículo -->
    <ng-template #detailsTemplate let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">Detalles del vehículo</h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="vehicle-details">
          <div>
            <small class="label">SAP ID</small>
            <div class="value">{{ selectedEntity?.sapId }}</div>
          </div>
          <div>
            <small class="label">Patente</small>
            <div class="value">{{ selectedEntity?.licensePlate }}</div>
          </div>
          <div>
            <small class="label">Transportista</small>
            <div class="value">{{ selectedEntity?.carrier?.name }}</div>
          </div>
          <div>
            <small class="label">Marca</small>
            <div class="value">
              {{ selectedEntity?.brand || "" | master : "VEHICLES#BRANDS" }}
            </div>
          </div>
          <div>
            <small class="label">Modelo</small>
            <div class="value">{{ selectedEntity?.model }}</div>
          </div>
          <div>
            <small class="label">Año de fabricación</small>
            <div class="value">{{ selectedEntity?.year }}</div>
          </div>
          <div>
            <small class="label">Antigüedad</small>
            <div class="value">
              {{ currentYear - (selectedEntity?.year || 0) }} año{{
                currentYear - (selectedEntity?.year || 0) === 1 ? "" : "s"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </ng-template>
  </div>
  <hr />
  <!-- Mensaje centrado cuando no se encuentra entidad -->
  <div
    class="col-sm-12 text-center my-5"
    *ngIf="entityNotFound && !isGettingEntity"
  >
    <div class="not-found-card">
      <div class="not-found-icon">
        <img src="/assets/images/icons/Alert.svg" alt="Advertencia" />
      </div>
      <h4>No hemos encontrado la</h4>
      <h4>evaluación</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
